<template>
  <div class="container content-block activate-account mt-5">
    <div v-if="activatingAccount">
      <div class="d-flex justify-content-center align-items-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Laden ...</span>
        </div>
        <span class="ml-2">Bezig met jouw account te activeren ...</span>
      </div>
    </div>
    <div v-else-if="activationSucceeded">
      <h3>Ga aan de slag!</h3>
      <p class="mt-3">
        Ga aan de slag! Je registratie is gelukt. Je kan nu inloggen op Beweegbuddy.
      </p>
      <router-link to="/login" class="btn btn-sandpiper btn-block mt-5">Aanmelden</router-link>
    </div>
    <div v-else>
      <p v-if="errorMessage">
        {{ errorMessage }}
      </p>
      <p v-else>
        Er ging iets fout bij het activeren van je account. Probeer het later opnieuw of contacteer support als het
        probleem zich blijft voordoen.
      </p>
    </div>
  </div>
</template>

<script>
import { AuthApi } from "sandpiper_api";
import log from "@/utils/logger";

export default {
  name: "ActivateAccount",
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      activatingAccount: true,
      activationSucceeded: false,
      activationCode: null,
      userId: null,
      errorMessage: ''
    };
  },
  methods: {
    fetchQueryParams()
    {
      this.userId = this.$route.query.userId ? parseInt(this.$route.query.userId) : null;
      this.activationCode = this.$route.query["activation-code"] || null;

      log.debug("Fetched query params:\nuserId: %s\nactivationCode: %s", this.userId, this.activationCode);
    },
    async activateAccount()
    {
      try
      {
        log.info("Trying to activate account for user [%s] with activation code [%s]", this.userId, this.activationCode);

        this.activatingAccount = true;

        await this.doApiRequest(() => new AuthApi().activateUserEmail({
          userId: this.userId,
          activationCode: this.activationCode
        }));

        this.activationSucceeded = true;
      }
      catch (e)
      {
        this.activationSucceeded = false;

        // TODO - handle error, show correct message
        if(e.body.error === "USERSIGNUP_ALREADY_ACTIVATED")
        {
          this.errorMessage = 'Jouw account is al gevalideerd';
        }
      }
      finally
      {
        this.activatingAccount = false;
      }
    }
  },
  created()
  {
    this.fetchQueryParams();

    if (this.activationCode === "dev-test" && this.userId === 1)
    {
      this.activatingAccount = true;
      setTimeout(() =>
      {
        this.activationSucceeded = false;
        this.activatingAccount = false;
        this.errorMessage = "Jouw account is al gevalideerd";
      }, 3000);
    }
    else if (this.activationCode !== null && this.userId !== null)
    {
      this.activateAccount();
    }
    else
    {
      this.$router.replace({ name: 'login' });
    }
  }
}
</script>

<style lang="scss" scoped>
.content-block
{
  padding: 25px;
}

.activate-account
{
  max-width: 400px;

  h3
  {
    font-weight: bold;
    font-size: 20px;
  }
}
</style>